<template>
    <div class="bg-gray" style="padding-top: 20px;padding-bottom: 20px;">
        <div id="swagger-ui"></div>
    </div>
</template>


<script>
import SwaggerUI from 'swagger-ui'
import 'swagger-ui/dist/swagger-ui.css'


export default {
    data() {
        return {
            url: '/api/swagger.json'
        }
    },
    mounted() {
        let queriesToRemove = {}
        Object.keys(this.$route.query).forEach(query => {
            queriesToRemove[query] = undefined
        })
        this.$router.replace({ query: queriesToRemove }).catch(() => {})
        SwaggerUI({
            url: this.url,
            dom_id: '#swagger-ui',
            // presets: [SwaggerUI.presets.ApisPreset],
            layout: 'BaseLayout',
        })
    }
}
</script>

<style lang="scss">
.bg-gray {
    background-color: #f7f7f9;
}

.info {
    text-align: center;
}

.version {
    background: none;
}
</style>
